import * as CubeTree from '../cubeTree/index';
import * as StageStatus from '../stageStatus';
import Utils from '../utils/util';
import Config from '../config/index';

// 计算货架区域逻辑高度，取最高的货架高度
function sketchpadPhysicsHeight(): PhysicsMeasurement {
    return StageStatus.isTopFace() ? cabinet() : shelf();
}

function shelf(): PhysicsMeasurement {
    let shelfs: CubeId[] = CubeTree.getCubeByType('shelf');
    let temp: Array<PhysicsMeasurement> = shelfs.map((cubeId: CubeId): PhysicsMeasurement => {
        return Utils.toNumber(CubeTree.getNumberValue(cubeId, 'height'));
    });
    let sort: PhysicsMeasurement[] = Utils.quickSort(temp);

    if (sort.length) {
        return sort[sort.length - 1];
    }

    return 0;
}

function cabinet(): PhysicsMeasurement {
    let shelfs: CubeId[] = CubeTree.getCubeByType('freezer');
    let temp: Array<PhysicsMeasurement> = shelfs.map((cubeId: CubeId): PhysicsMeasurement => {
        return Utils.toNumber(CubeTree.getNumberValue(cubeId, 'depth'));
    });
    let sort: PhysicsMeasurement[] = Utils.quickSort(temp);

    if (sort.length) {
        return sort[sort.length - 1];
    }

    return 0;
}

export {
    sketchpadPhysicsHeight
};
